export const ADD_TEAMS = 'ADD_TEAMS'
export const UPDATE_TEAMS = 'UPDATE_TEAMS';
export const DELETE_TEAMS = 'DELETE_TEAMS'
export const GET_TEAMS = 'GET_TEAMS'
export const SET_LOADING = 'SET_LOADING';
export const GET_TEAM_BY_ID = 'GET_TEAM_BY_ID';
export const GET_MEMBER_BY_TEAMID = 'GET_MEMBER_BY_TEAMID';
export const ADD_CO_MANAGER = 'ADD_CO_MANAGER';
export const GET_CO_MANAGERS = 'GET_CO_MANAGERS';
export const ADD_PLAYER = 'ADD_PLAYER';
export const GET_YOUR_TEAM = 'GET_YOUR_TEAM';
export const GET_PAYMENT_RECORDS = 'GET_PAYMENT_RECORDS';
export const GET_PENDING_PAYMENT_RECORDS = 'GET_PENDING_PAYMENT_RECORDS';
export const GET_PLAYERS = 'GET_PLAYERS';

export const CLEAR_TEAM = 'CLEAR_TEAM'; 
export const GET_PENDING_INVITATIONS_REQUEST = 'GET_PENDING_INVITATIONS_REQUEST';
export const GET_PENDING_INVITATIONS_SUCCESS = 'GET_PENDING_INVITATIONS_SUCCESS';
export const GET_PENDING_INVITATIONS_FAILURE = 'GET_PENDING_INVITATIONS_FAILURE';
export const ADD_MANAGER = "ADD_MANAGER";
